export default function EFNAS(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 29 28" fill="none" {...props}>
            <path
                d="M23.6875 5.25H5.3125C4.58763 5.25 4 5.83763 4 6.5625V20.5625C4 21.2874 4.58763 21.875 5.3125 21.875H23.6875C24.4124 21.875 25 21.2874 25 20.5625V6.5625C25 5.83763 24.4124 5.25 23.6875 5.25Z"
                stroke="currentColor"
                strokeWidth="1.05"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9.25 5.25L9.25 21.875" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.5 5.25L14.5 21.875" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.75 5.25V21.875" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.75 8.75H21.5" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.5 8.75H16.25" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.25 8.75H11" stroke="currentColor" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="6.625" cy="18.375" r="0.875" fill="currentColor" />
        </svg>
    );
}
